import { valueOf } from "@/types/common";

export const COMPANY_LIST_TAB = {
  DURING_CONTRACT: "DURING_CONTRACT",
  EXPIRED_CONTRACT: "EXPIRED_CONTRACT",
  TRIAL: "TRIAL",
  TRIAL_CANCELLED: "TRIAL_CANCELLED",
};

export type TRsoListTab = valueOf<typeof COMPANY_LIST_TAB>;

export const COMPANY_LIST_TAB_LABEL = {
  [COMPANY_LIST_TAB.DURING_CONTRACT]: "契約中の企業一覧",
  [COMPANY_LIST_TAB.EXPIRED_CONTRACT]: "解約済みの企業一覧",
  [COMPANY_LIST_TAB.TRIAL]: "トライアル中の企業一覧",
  [COMPANY_LIST_TAB.TRIAL_CANCELLED]: "トライアル終了の企業一覧",
};
